/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "utils/string",
  "backbone"
], function (
  StringUtils,
  Backbone
) {

  Backbone.Collection.prototype.dispose = Backbone.Collection.prototype.dispose || function () {
    this.stopListening();
  };

  Backbone.Collection.prototype.nextName = function (prefix, suffix) {
    prefix = prefix || this._namePrefix || "";
    var regex = new RegExp("^" + prefix + "(\\d+)"),
        index = 1;

    this.models.forEach(function (tab) {
        var name = tab.get("name"),
            match = name.match(regex);

        if (match) {
          index = Math.max(index, parseInt(match[1], 10) + 1);
        }
    });

    return prefix + index + (suffix || "");
  };

  Backbone.Collection.prototype.nameFromQuery = function (query, suffix) {
    var name = StringUtils.trim(query && !query.label && query.unparsed),
        nameTaken;
    
    if (name && suffix) {
      name += suffix	
    }
    
    nameTaken = this.isNameTaken(name);

    if (nameTaken) return this.nextName(name + " ");
    return name;
  };

  Backbone.Collection.prototype.isNameTaken = function (name, own) {
    return this.find(function (model) {
        return model !== own && model.get("name") === name;
    });
  };

});
